import React from "react";
import FormSelect from "components/admin_v2/ui/FormSelect";
import { get } from "lodash";
import AddressNewForm from "./AddressNewForm";

const AddressStudentForm = (props) => {
  const { store, stopType, tripType, cls, disabled = false } = props;
  const [state, actions] = store;

  if (state.studentAddresses?.length === 1) {
    return <AddressNewForm {...props} disabled={true} />;
  }

  const stop = get(state.stops, `${tripType}.${stopType}`);
  const onChange = (e) => {
    actions.setStopLocation({ stopLocation: { address: e.target.value }, stopType, tripType });
  };

  return (
    <FormSelect
      itemType="student"
      i18Key="stop"
      options={state.studentAddresses}
      value={stop?.stopLocation?.address}
      onChange={onChange}
      cls={cls}
      clsKeys={["select", "select"]}
      withoutLabel={true}
      disabled={disabled}
      required
    />
  );
};

export default AddressStudentForm;
